export default {
  brand: 'Brand Admin',
  dashboard: 'Dashboard',
  products: 'Products',
  antiFake: 'Anti-Fake',
  scanTemplate: 'Scan Template',
  scanTemplateEditor: 'Template Editor',
  supplyChain: 'Supply Chain',
  production: 'Production',
  members: 'Members',
  memberList: 'Member List',
  memberDetail: 'Member Detail',
  memberLevelPrivilege: 'Member Level Privilege',
  memberDecoration: 'Member Decoration',
  blacklistManagement: 'Blacklist Management',
  memberManagement: 'Member Management',
  memberBasicConfig: 'Basic Config',
  points: 'Points',
  pointsIssueDetail: 'Issue Details',
  pointsIssueStats: 'Issue Statistics',
  pointsConfig: 'Points Config',
  marketing: 'Marketing',
  activityManagement: 'Activity Management',
  activityList: 'Activity List',
  activityAdd: 'Create Activity',
  activityEdit: 'Edit Activity',
  activityDetail: 'Activity Detail',
  drawRecord: 'Draw Record',
  giftClaimRecord: 'Gift Claim Record',
  activityTemplate: 'Activity Template',
  activityTemplateEditor: 'Template Editor',
  marketingData: 'Marketing Data',
  mall: 'Points Mall',
  pointsMall: 'Points Mall',
  pointsProduct: 'Points Products',
  pointsProductAddEdit: 'Add/Edit Gift',
  pointsProductCategory: 'Product Category',
  exchangeRecord: 'Exchange Record',
  mallDecoration: 'Mall Decoration',
  exchangeStats: 'Exchange Statistics',
  dealers: 'Dealers',
  settings: 'Settings',
  reports: 'Reports',
  code: 'Code Management',
  codeManagement: 'Code Management',
  codeBatchList: 'Code Batch List',
  codeStatusControl: 'Code Status Control',
  antiFakeTrace: 'Anti-Fake Trace',
  productLinkTemplate: 'Product Link Template',
  scanDetail: 'Scan Detail',
  alertRecord: 'Alert Record',
  alertSetting: 'Alert Setting',
  productCodeAssignment: 'Product Code Assignment',
  merchants: 'Merchants',
  companyInfo: 'Company Info',
  emailConfig: 'Email Config',
  smsConfig: 'SMS Config',
  i18nManagement: 'I18n Management',
  paymentAuthConfig: 'Payment & Auth Config',
  systemSettings: 'System Settings',
  roleManagement: 'Role Management',
  accountManagement: 'Account Management',
  operationLog: 'Operation Log',
  afterSaleFeedback: 'After-sale Feedback',
  productLibrary: 'Product Library',
  productList: 'Product List',
  productAdd: 'Add Product',
  productEdit: 'Edit Product',
  productCategory: 'Product Category',
  productAttribute: 'Product Attribute',
  giftLibrary: 'Gift Library',
  giftList: 'Gift List',
  giftAdd: 'Add Gift',
  giftEdit: 'Edit Gift',
  giftCategory: 'Gift Category',
  productionInfo: 'Production Info',
  productionBatch: 'Production Batch',
  batchAdd: 'Add Production Batch',
  batchEdit: 'Edit Production Batch',
  factoryManagement: 'Factory Management',
  materialLibrary: 'Material Library',
  memberLevelAdd: 'Add Member Level',
  memberLevelEdit: 'Edit Member Level',
};
